export default {"src":"/_next/static/media/invisible.037c31cb.svg","height":512,"width":512};